import { render, staticRenderFns } from "./ImportChangesList.vue?vue&type=template&id=66e454b2"
import script from "./ImportChangesList.vue?vue&type=script&lang=js"
export * from "./ImportChangesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports